import {
  Home,
  MessageSquare,
  Bot,
  BarChart3,
  Settings,
  Users,
  FileText,
  Zap,
  ChevronLeft,
  ChevronRight,
  Plus,
  Star,
  Clock,
  Trash2,
  X,
  Code,
  User,
  CreditCard,
  HelpCircle,
  UserCheck,
  Package
} from 'lucide-react'
import { useChat } from '../../contexts/ChatContext'
import { useTheme } from '../../contexts/ThemeContext'
import SubMenu from './SubMenu'
import talkidaLogo from '../../assets/icons/horizontal-logo-colored.png'
import { Link, useLocation } from 'react-router-dom'

const Sidebar = ({ isCollapsed, isMobileMenuOpen, setIsMobileMenuOpen }) => {
  const { chats, activeChat, setActiveChat } = useChat()
  const { toggleSidebar } = useTheme()
  const location = useLocation()

  const mainMenuItems = [
    {
      icon: Home,
      label: 'Dashboard',
      href: '/dashboard'
    },
    {
      icon: Package,
      label: 'Products',
      href: '/products'
    },
    // {
    //   icon: Bot,
    //   label: 'Bots',
    //   href: '/dashboard/bots'
    // },
    {
      icon: Code,
      label: 'Widgets',
      href: '/dashboard/widgets'
    },
    {
      icon: UserCheck,
      label: 'Leads',
      href: '/dashboard/leads'
    },
  ]

  // Function to check if a menu item is active
  const isActiveRoute = (href) => {
    if (href === '/dashboard') {
      return location.pathname === '/' || location.pathname === '/dashboard'
    }
    return location.pathname === href
  }

  return (
    <>
      {/* Desktop Sidebar */}
      <div className={`hidden lg:flex flex-col h-full bg-secondary-800/50 backdrop-blur-sm border-r border-secondary-700/50 transition-all duration-300 ${isCollapsed ? 'w-16' : 'w-64'
        }`}>
        {/* Header */}
        <div className="p-4 border-b border-secondary-700/50">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <img
                  src={talkidaLogo}
                  alt="Talkida Smart Chat Solutions"
                  className="h-10 object-contain"
                />
              </div>
            </div>
            <button
              onClick={toggleSidebar}
              className="p-2 rounded-lg hover:bg-secondary-700 transition-colors"
            >
              {isCollapsed ? (
                <ChevronRight className="w-5 h-5 text-white" />
              ) : (
                <ChevronLeft className="w-5 h-5 text-white" />
              )}
            </button>
          </div>
        </div>

        {/* Main Navigation */}
        <nav className="flex-1 p-4 space-y-2">
          {mainMenuItems.map((item, index) => {
            const isActive = isActiveRoute(item.href)
            return (
              <Link
                key={index}
                to={item.href}
                className={`flex items-center space-x-3 px-3 py-2 rounded-lg transition-all duration-200 group ${isActive
                  ? 'bg-primary-500/20 text-primary-400 border border-primary-500/30'
                  : 'text-secondary-300 hover:bg-secondary-700 hover:text-white'
                  }`}
              >
                <item.icon className={`w-5 h-5 ${isCollapsed ? 'mx-auto' : ''}`} />
                {!isCollapsed && (
                  <>
                    <span className="flex-1">{item.label}</span>
                    {item.count !== undefined && (
                      <span className="bg-primary-500 text-white text-xs px-2 py-1 rounded-full">
                        {item.count}
                      </span>
                    )}
                  </>
                )}
              </Link>
            )
          })}
        </nav>
      </div>

      {/* Mobile Sidebar */}
      <div className={`lg:hidden fixed inset-y-0 left-0 z-50 w-64 bg-secondary-800 border-r border-secondary-700 transform transition-transform duration-300 ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
        }`}>
        <div className="flex flex-col h-full">
          {/* Mobile Header */}
          <div className="p-4 border-b border-secondary-700">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="flex-shrink-0">
                  <img
                    src={talkidaLogo}
                    alt="Talkida Smart Chat Solutions"
                    className="w-8 h-8 object-contain"
                  />
                </div>
                <div>
                  <h2 className="text-lg font-bold ai-text-gradient">Talkida</h2>
                  <p className="text-xs text-secondary-400 font-medium">Smart Chat Solutions</p>
                </div>
              </div>
              <button
                onClick={() => setIsMobileMenuOpen(false)}
                className="p-2 rounded-lg hover:bg-secondary-700 transition-colors"
              >
                <X className="w-5 h-5 text-white" />
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          <nav className="flex-1 p-4 space-y-2">
            {mainMenuItems.map((item, index) => {
              const isActive = isActiveRoute(item.href)
              return (
                <Link
                  key={index}
                  to={item.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`flex items-center space-x-3 px-3 py-2 rounded-lg transition-all duration-200 ${isActive
                    ? 'bg-primary-500/20 text-primary-400 border border-primary-500/30'
                    : 'text-secondary-300 hover:bg-secondary-700 hover:text-white'
                    }`}
                >
                  <item.icon className="w-5 h-5" />
                  <span className="flex-1">{item.label}</span>
                  {item.count !== undefined && (
                    <span className="bg-primary-500 text-white text-xs px-2 py-1 rounded-full">
                      {item.count}
                    </span>
                  )}
                </Link>
              )
            })}
          </nav>
        </div>
      </div>
    </>
  )
}

export default Sidebar
